import { formatCurrency } from '@/lib/number-utils'
import { UserCurrency } from '@/types/common'

export function getPriceLabel({
	currency: priceCurrency,
	price,
	keepZeroes,
}: {
	currency: UserCurrency
	price: number | null
	keepZeroes?: boolean
}) {
	return formatCurrency(price ?? 0, {
		removeZeroes: !keepZeroes,
		currency: priceCurrency,
	})
}
